import { WbDrawer, WbDrawerContent } from '@agilelab/plugin-wb-platform';
import {
  TechDocsReaderPage,
  TechDocsReaderPageContent,
} from '@agilelab/plugin-wb-techdocs';
import { DEFAULT_NAMESPACE, Entity } from '@backstage/catalog-model';
import { useCallback, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';

export function useTechDocsDrawer() {
  const [showDocs, setShowDocs] = useState(false);
  const [currentEntity, setCurrentEntity] = useState<Entity | null>(null);

  const location = useLocation();
  const navigate = useNavigate();
  const { '*': docsSubPath = '' } = useParams();

  const openDocs = useCallback(
    (entity: Entity) => {
      // If the URL has a docs sub-path from a previous docs navigation,
      // reset it to avoid opening the new entity's docs on a stale page.
      if (docsSubPath) {
        const cleanPath = location.pathname.slice(
          0,
          location.pathname.length - docsSubPath.length,
        );
        navigate(cleanPath, { replace: true });
      }
      setCurrentEntity(entity);
      setShowDocs(true);
    },
    [docsSubPath, location.pathname, navigate],
  );

  const entityRef = currentEntity
    ? {
        namespace: currentEntity.metadata.namespace ?? DEFAULT_NAMESPACE,
        kind: currentEntity.kind,
        name: currentEntity.metadata.name,
      }
    : undefined;

  const title = currentEntity
    ? `${
        currentEntity.metadata.title || currentEntity.metadata.name
      } Documentation`
    : '';

  const TechDocsDrawer = (
    <WbDrawer open={showDocs} setOpen={setShowDocs} title={title}>
      {entityRef && (
        <WbDrawerContent>
          <TechDocsReaderPage
            onClose={() => setShowDocs(false)}
            entityRef={entityRef}
          >
            <TechDocsReaderPageContent />
          </TechDocsReaderPage>
        </WbDrawerContent>
      )}
    </WbDrawer>
  );

  return { openDocs, TechDocsDrawer };
}
